export function safeJSONParse<T>(
  jsonStr: string,
  defaultValue: T | undefined = undefined,
): T {
  try {
    return JSON.parse(jsonStr) as T
  } catch (err) {
    console.warn(err)
    return defaultValue as T
  }
}
